// JS
import React, { useEffect, useState } from 'react';
import { randomId } from '../shared/utils';
import Slider from '../Slider';

// COMPOONENTS
import Product from '../Product';
import Button from '../Button';
import { Skeleton } from '../Ui/skeleton';

// COMPONENT
const NewArrivalsSlider = ({
  getProductData,
  newArrivalsButtonLink,
  gaBlockName,
  blackFriday,
  blackFridayBadge,
  isSeventhImage = false,
  badgeClasses
}) => {
  const uniqueId = randomId();
  const [productData, setProductData] = useState(null);

  // GET DATA FROM NQ
  const getData = getProductData;

  // API DATA
  useEffect(() => {
    if (getData && getData.data) {
      setProductData(getData.data.products.products);
    }
  }, [getData]);

  return (
    <React.Fragment>
      {getData ? (
        <Slider
          name="new-arrivals-section-slider"
          responsive={{
            sm: { show: 1, spaceBetween: 10 },
            lg: { show: 3 },
            xl: { show: 4, spaceBetween: 12 }
          }}
          useGrid={true}
          usePagination={true}
          paginationOptions={{
            rounded: true,
            noContain: true,
            classes: {
              wrapper:
                '!justify-start !mt-1 md:!justify-center md:!mt-10 lg:hidden'
            }
          }}
        >
          {productData &&
            productData.map((slide, i) => {
              return (
                <Product
                  key={'product-key-' + uniqueId}
                  productID={slide.product.productid}
                  productURL={slide.product.url}
                  productName={slide.product.name}
                  productPosition={i + 1}
                  productCategory={slide.product.attributes.product_category}
                  productBrand={slide.product.attributes.brand}
                  productImage={
                    isSeventhImage
                      ? slide.product.attributes.alternatives.slice(-1)
                      : slide.product.image
                  }
                  productImageAlternate={slide.product.attributes.alternative}
                  productPrice={slide.product.option.price}
                  productPromotionPrice={slide.product.option.promotionprice}
                  productAspectOptions={{
                    classes: 'lg:aspect-h-11'
                  }}
                  gaBlockName={gaBlockName}
                  blackFriday={blackFriday}
                  blackFridayBadge={blackFridayBadge}
                  badgeClasses={badgeClasses}
                />
              );
            })}
        </Slider>
      ) : (
        <div className="w-full grid gap-5 md:grid-cols-3 lg:grid-cols-4">
          <div className="flex flex-col h-[400px] md:h-[335px] xl:h-[450px] 2xl:h-[525px]">
            <Skeleton className="aspect-square h-[360px] md:h-[290px] xl:h-[360px] 2xl:h-[440px] mb-4" />
            <Skeleton className="aspect-square w-[160px] h-[15px] mb-1" />
            <Skeleton className="aspect-square w-[160px] h-[15px] mb-4" />
            <Skeleton className="aspect-square w-[160px] h-[15px]" />
          </div>
          <div className="hidden md:flex flex-col h-[400px] md:h-[335px] xl:h-[450px] 2xl:h-[525px]">
            <Skeleton className="aspect-square h-[360px] md:h-[290px] xl:h-[360px] 2xl:h-[440px] mb-4" />
            <Skeleton className="aspect-square w-[160px] h-[15px] mb-1" />
            <Skeleton className="aspect-square w-[160px] h-[15px] mb-4" />
            <Skeleton className="aspect-square w-[160px] h-[15px]" />
          </div>
          <div className="hidden md:flex flex-col h-[400px] md:h-[335px] xl:h-[450px] 2xl:h-[525px]">
            <Skeleton className="aspect-square h-[360px] md:h-[290px] xl:h-[360px] 2xl:h-[440px] mb-4" />
            <Skeleton className="aspect-square w-[160px] h-[15px] mb-1" />
            <Skeleton className="aspect-square w-[160px] h-[15px] mb-4" />
            <Skeleton className="aspect-square w-[160px] h-[15px]" />
          </div>
          <div className="hidden lg:flex flex-col h-[400px] md:h-[335px] xl:h-[450px] 2xl:h-[525px]">
            <Skeleton className="aspect-square h-[360px] md:h-[290px] xl:h-[360px] 2xl:h-[440px] mb-4" />
            <Skeleton className="aspect-square w-[160px] h-[15px] mb-1" />
            <Skeleton className="aspect-square w-[160px] h-[15px] mb-4" />
            <Skeleton className="aspect-square w-[160px] h-[15px]" />
          </div>
        </div>
      )}

      <Button
        buttonColour="black"
        buttonLink={newArrivalsButtonLink}
        buttonLinkText="View All"
        buttonAdditionalClasses={{
          classes: 'mt-7 md:mt-14 md:!w-1/3 lg:!w-1/4'
        }}
        gaBlockTitle={'View All'}
        gaBlockName={gaBlockName}
        gaBlockId={uniqueId}
      />
    </React.Fragment>
  );
};

export default NewArrivalsSlider;
